import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react'; // optional: install `lucide-react` or use plain SVG
import project1 from '../assets/project1.png';
import project2 from '../assets/project2.png';
import project3 from '../assets/project3.png';
import project4 from '../assets/project4.png';
import project5 from '../assets/project5.png';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const projectData = [
  { id: 1, title: 'BETIRET APARTMENT', image: project1 },
  { id: 2, title: 'MANSION HOUSE', image: project2 },
  { id: 3, title: 'AFRICA UNION OFFICE', image: project3 },
  { id: 4, title: 'HAYAT APARTMENT', image: project4 },
  { id: 5, title: 'HAYA-HULET APARTMENT', image: project5 },
];

const ProjectsCarousel = () => {
  const carouselRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const scroll = (direction) => {
    const { current } = carouselRef;
    if (current) {
      const scrollAmount = 300;
      current.scrollBy({ left: direction === 'left' ? -scrollAmount : scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-[#f0f4fa] px-6 py-16 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {/* Title */}
        {loading ? (
          <Skeleton height={40} width={220} className="mb-8" style={{ marginBottom: 32, borderRadius: 8 }} />
        ) : (
          <h2 className="text-3xl font-extrabold text-[#003A7D] uppercase mb-8">Our Work</h2>
        )}

        {/* Carousel */}
        <div className="relative">
          <div
            ref={carouselRef}
            className="flex space-x-6 overflow-x-auto scroll-smooth pb-4 no-scrollbar"
          >
            {loading
              ? Array.from({ length: 5 }).map((_, idx) => (
                  <div key={idx} className="min-w-[250px] lg:min-w-[280px] flex-shrink-0 text-center">
                    <Skeleton className="w-full h-96" style={{ borderRadius: 12, height: '384px' }} />
                    <Skeleton height={20} width={120} style={{ margin: '16px auto 0', borderRadius: 8 }} />
                  </div>
                ))
              : projectData.map((project) => (
                  <div
                    key={project.id}
                    className="min-w-[250px] lg:min-w-[280px] flex-shrink-0 text-center"
                  >
                    <div className="w-full h-[30rem] overflow-hidden shadow-md">
                      <img
                        src={project.image}
                        alt={project.title}
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <p className="mt-2 text-left text-base font-medium text-black">{project.title}</p>
                  </div>
                ))}
          </div>

          {/* Arrows */}
          <div className="flex justify-between items-center mt-6 px-4 lg:px-0">
            {loading ? (
              <>
                <Skeleton circle height={40} width={40} />
                <Skeleton circle height={40} width={40} />
              </>
            ) : (
              <>
                <button
                  onClick={() => scroll('left')}
                  className="p-2 bg-white rounded-full shadow hover:bg-blue-100 transition"
                >
                  <ChevronLeft className="w-5 h-5 text-[#003A7D]" />
                </button>
                <button
                  onClick={() => scroll('right')}
                  className="p-2 bg-white rounded-full shadow hover:bg-blue-100 transition"
                >
                  <ChevronRight className="w-5 h-5 text-[#003A7D]" />
                </button>
              </>
            )}
          </div>

          {/* CTA Button */}
          <div className="mt-8 text-center">
            {loading ? (
              <Skeleton height={40} width={220} style={{ borderRadius: 20, margin: '0 auto' }} />
            ) : (
              <button
                className="bg-[#003A7D] hover:bg-blue-900 text-white px-6 py-3 text-sm font-semibold"
                onClick={() => navigate('/works')}
              >
                VIEW ALL PROJECTS
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsCarousel;